const BOT_TOKENS = [
	// Search engines
	'googlebot',
	'google-inspectiontool',
	'storebot-google',
	'bingbot',
	'yandexbot',
	'duckduckbot',
	'baiduspider',
	'applebot',
	'petalbot',
	'seznambot',
	// SEO and uptime monitoring
	'ahrefsbot',
	'semrushbot',
	'mj12bot',
	'dotbot',
	'dataforseobot',
	'uptimerobot',
	'pingdom',
	'chrome-lighthouse',
	// Link unfurlers
	'facebookexternalhit',
	'twitterbot',
	'linkedinbot',
	'slackbot',
	'telegrambot',
	'discordbot',
	'whatsapp',
	'skypeuripreview',
	'embedly',
	// Headless and scripted clients
	'headlesschrome',
	'phantomjs',
	'puppeteer',
	'playwright',
	'prerender',
	'python-requests',
	'scrapy',
	'curl/',
	'wget/',
	// Agents that declare themselves: "Somebot/2.1 (+http://example.com/bot.html)".
	// The slash matters – a bare "bot" also matches phone brands like CUBOT.
	'crawler',
	'spider',
	'bot/',
	'+http',
];

export const isBotUserAgent = (userAgent: string): boolean => {
	const normalized = userAgent.toLowerCase();

	return BOT_TOKENS.some((token) => normalized.includes(token));
};
